import script from "./AuthSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthSection.vue?vue&type=script&setup=true&lang=js"

import "./AuthSection.vue?vue&type=style&index=0&id=d2760a86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2760a86"]])

export default __exports__